import Store from 'store/store';

Store.on('TOGGLE_ONESHEET', (expandedId) => {
	Store.get().synopsis.set({ onesheetExpanded: expandedId });

	Store.emit(expandedId !== null ? 'ENABLE_SCROLLING_LOCK' : 'DISABLE_SCROLLING_LOCK');

	if (expandedId !== null) {
		Store.emit('SET_HEADER_ACTION', {
			icon: 'close',
			action: () => Store.emit('TOGGLE_ONESHEET', false),
			tag: 'closeOnesheetOverlay',
		});
	} else {
		Store.emit('REMOVE_HEADER_ACTIONS', 'closeOnesheetOverlay');
	}
});

Store.on('CLOSE_ALL_OVERLAYS', () => {
	Store.emit('TOGGLE_ONESHEET', null);
});

Store.on('ADD_FOOTER_SHADOW', (bool) => {
	if (!Store.get().synosis) {
		Store.get().set({ synopsis: {} });
	}
	Store.get().synopsis.set({ addShadowToFooter: bool });
});
